import { render, staticRenderFns } from "./RepublishNotification.vue?vue&type=template&id=4b743d7d&scoped=true"
import script from "./RepublishNotification.vue?vue&type=script&lang=js"
export * from "./RepublishNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b743d7d",
  null
  
)

export default component.exports